import React from "react";
import bgImg from "../Assets/Images/analog-landscape-city-with-buildings.jpg";
import TeamProfiles from "../Components/TeamProfile"
import AboutUs from "../Components/AboutUs";

const About = () => {
  return (
    <div>
      <div className="relative bg-secondaryx h-96">
        <img
          className="absolute inset-0 w-full h-full object-cover mix-blend-overlay"
          src={bgImg}
          alt="NGO volunteers"
        />
        <div className="absolute inset-0 bg-secondaryx bg-opacity-75"></div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
            About us
          </h1>
          <p className="mt-6 text-xl text-blue-100 max-w-3xl">
            Comprehensive real estate solutions driving value and innovation
            across Africa
          </p>
        </div>
      </div>

      <div className="mt-10 p-5">
        <h1 className="text-4xl font-roboto text-left font-bold mb-12 text-primary">
          RamaDreams Real Estate
        </h1>
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-6 mt-6">
          <p className="text-gray-600 text-left font-light">
            Harbourage Ltd is a real estate firm dedicated to redefining urban
            landscapes through visionary property development. With a commitment
            to excellence, innovation, and sustainable growth, Harbourage Ltd is
            establishing itself as a vanguard in the real estate industry,
            consistently delivering projects that elevate standards and exceed
            expectations.
          </p>
          <p className="text-gray-600 text-left font-light">
            Incorporated in 2022, formed by a coalition of industry leaders with
            about two decades of experience in design and development, project
            management, and financial services. This wealth of expertise
            positions us at the forefront of the real estate sector, enabling us
            to deliver projects that embody excellence, innovation, and
            sustainable growth.
          </p>
        </div>
      </div>

      <section className="flex flex-col lg:flex-row lg:justify-evenly lg:items-center gap-6 mt-6">
        <div className=" text-center">
          <h2 className="text-6xl text-primary font-medium font-roboto">13+</h2>
          <p className="text-md text-secondary font-light my-3">
            Delivered Projects
          </p>
        </div>

        <div className=" text-center">
          <h2 className="text-6xl text-primary font-medium font-roboto">
            180+
          </h2>
          <p className="text-md text-secondary font-light my-3">
            Happy Customers
          </p>
        </div>

        <div className=" text-center">
          <h2 className="text-6xl text-primary font-medium font-roboto">70+</h2>
          <p className="text-md text-secondary font-light my-3">
            Properties Available
          </p>
        </div>
      </section>

      <AboutUs />

      <TeamProfiles />
    </div>
  );
};

export default About;
